import { router } from '@/router'
import { mainAxios, chatAxios, TOKEN_AUTH, TOKEN_VERIFY,
  TOKEN_REFRESH, LOGOUT_ALL, CHAT_TOKEN_AUTH } from '@/backend/vue-axios'
import store from '@/store'
import {
  CHAT_LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS
} from './authentication-mutation-types'
import { POST_REQUEST } from './mutation-types'

// initial state
const state = {
  loading: false,
  isAuthenticated: false,
  authToken: null,
  chatAuthToken: null,
  chatBearerToken: null
}

function handleErrorResponse (error) {
  // console.log(error.response)
  const statusCode = error.response.status
  let message = ''
  switch (true) {
    case (statusCode >= 400):
      message = 'Authentication failed. Please provide valid username and password.'
      break
    case (statusCode === 500):
      message = 'Internal error. Please try again'
      break
    default:
      message = error.response.data.errors
      break
  }
  store.dispatch('alert/error', message).catch(error => {
    console.error(error)
  })
}

const getters = {
  getChatAuthToken: (state) => {
    return state.chatAuthToken
  },
  getChatBearerToken: (state) => {
    return state.chatBearerToken
  },
  getLoginAuthToken: (state) => {
    return state.authToken
  },
  isAuthenticated: (state) => {
    return state.isAuthenticated
  },
  isLoading: (state) => {
    return state.loading
  }
}

// actions
const actions = {
  async restTokenAuth ({ commit }, { username, password }) {
    commit(POST_REQUEST, { val: true })
    mainAxios.defaults.headers.common['Authorization'] = ''
    mainAxios.post(TOKEN_AUTH, { username: username, password: password })
      .then(request => {
        commit(LOGIN_SUCCESS, request.data)
        router.push({ path: '/dashboard' })
      })
      .catch(error => {
        commit(LOGIN_FAILURE)
        handleErrorResponse(error)
      })
  },
  async restTokenValidate ({ commit }) {
    commit(POST_REQUEST, { val: true })
    const token = store.state.authentication.authToken
    return mainAxios.post(TOKEN_VERIFY, { token: token })
      .then(request => {
        if (request.data.token) {
          commit(LOGIN_SUCCESS, request.data)
          return true
        } else {
          commit(LOGIN_FAILURE)
          store.dispatch('alert/error',
            'User validation failed')
          return false
        }
      }).catch(error => {
        commit(LOGIN_FAILURE)
        handleErrorResponse(error)
        return false
      })
  },
  async restTokenRefresh ({ commit }) {
    commit(POST_REQUEST, { val: true })
    const token = store.state.authentication.authToken
    mainAxios.post(TOKEN_REFRESH, { token: token })
      .then(request => {
        commit(LOGOUT_SUCCESS, request.data)
        router.push({ path: '/login' })
      })
      .catch(error => {
        commit(LOGOUT_FAILURE)
        router.push({ path: '/login' })
        handleErrorResponse(error)
      })
  },
  async logOutAll ({ commit }) {
    try {
      commit(POST_REQUEST, { val: true })
      const token = store.state.authentication.authToken
      await mainAxios.post(LOGOUT_ALL, {}, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `JWT ${token}` : ''
        } })
      this._vm.$socket.disconnect()
      commit(LOGOUT_SUCCESS, 'logout all sessions successfully')
      router.push({ path: '/login' })
    } catch (e) {
      commit(LOGOUT_FAILURE)
      this._vm.$socket.disconnect()
      store.dispatch('alert/error', e.message)
      router.push({ path: '/login' })
    }
  },
  // chat server
  async chatRestTokenAuth ({ commit }, { username, password }) {
    chatAxios.defaults.headers.common['Authorization'] = ''
    chatAxios.post(CHAT_TOKEN_AUTH, { username: username, password: password })
      .then(request => {
        commit(CHAT_LOGIN_SUCCESS, request.data)
        // commit(LOGIN_SUCCESS, request.data)
        // router.push({ path: '/dashboard' })
      })
      .catch(error => {
        commit(LOGIN_FAILURE)
        handleErrorResponse(error)
      })
  }
}

// mutations
const mutations = {
  [POST_REQUEST] (state, { val }) {
    state.loading = val
  },
  [LOGIN_SUCCESS] (state, data) {
    state.loading = false
    state.isAuthenticated = true
    state.authToken = data.token
    store.dispatch('account/setUser', { val: data.user })
  },
  [CHAT_LOGIN_SUCCESS] (state, data) {
    // console.log('CHAT_LOGIN_SUCCESS', data)
    state.chatAuthToken = data.twilioAccount.authToken
    state.chatBearerToken = data.token
  },
  [LOGIN_FAILURE] (state) {
    state.loading = false
    state.isAuthenticated = false
    state.authToken = null
    store.dispatch('account/setUser', { val: null })
  },
  [LOGOUT_SUCCESS] (state) {
    state.loading = false
    state.isAuthenticated = false
    state.authToken = null
    state.chatAuthToken = null
    state.chatBearerToken = null
    store.dispatch('account/setUser', { val: null })
    store.dispatch('contact/clear')
    store.dispatch('group/clear')
    store.dispatch('category/clear')
    store.dispatch('interest/clear')
  },
  [LOGOUT_FAILURE] (state) {
    state.loading = false
    state.isAuthenticated = false
    state.authToken = null
    state.chatAuthToken = null
    state.chatBearerToken = null
    store.dispatch('account/setUser', { val: null })
    store.dispatch('contact/clear')
    store.dispatch('group/clear')
    store.dispatch('category/clear')
    store.dispatch('interest/clear')
  }
}

export const authentication = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
